import APIURL from "../axios";
import { useQuery } from "react-query";

// const getLang = () => {
//   return sessionStorage.getItem("lang");
// };
const HomePage = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}/qr-code`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowHomeMenu = (uuid, lang) => {
  return useQuery(`home_menu-${uuid}-${lang}`, () => HomePage(uuid, lang));
};
const CheckUUID = async (uuid, lang) => {
  return await APIURL.get(`/${uuid}`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      lang: lang,
    },
  });
};
export const ShowCheckUUID = (uuid) => {
  return useQuery(`CheckUUID`, () => CheckUUID(uuid));
};
